import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Text from "../Text";
var Heading = Text.withComponent('p', {
  target: "e13es6xl0",
  label: "Heading"
});
Heading.defaultProps = _objectSpread(_objectSpread({}, Text.defaultProps), {}, {
  m: 0,
  mb: 2,
  textStyle: 'h3'
});
Heading.h1 = Heading.withComponent('h1', {
  target: "e13es6xl1"
});
Heading.h1.defaultProps = _objectSpread(_objectSpread({}, Heading.defaultProps), {}, {
  textStyle: 'h1'
});
Heading.h2 = Heading.withComponent('h2', {
  target: "e13es6xl2"
});
Heading.h2.defaultProps = _objectSpread(_objectSpread({}, Heading.defaultProps), {}, {
  textStyle: 'h2'
});
Heading.h3 = Heading.withComponent('h3', {
  target: "e13es6xl3"
});
Heading.h3.defaultProps = _objectSpread(_objectSpread({}, Heading.defaultProps), {}, {
  textStyle: 'h3'
});
Heading.h4 = Heading.withComponent('h4', {
  target: "e13es6xl4"
});
Heading.h4.defaultProps = _objectSpread(_objectSpread({}, Heading.defaultProps), {}, {
  textStyle: 'h4'
});
Heading.h5 = Heading.withComponent('h5', {
  target: "e13es6xl5"
});
Heading.h5.defaultProps = _objectSpread(_objectSpread({}, Heading.defaultProps), {}, {
  textStyle: 'h5'
});
Heading.h6 = Heading.withComponent('h6', {
  target: "e13es6xl6"
});
Heading.h6.defaultProps = _objectSpread(_objectSpread({}, Heading.defaultProps), {}, {
  textStyle: 'h6'
});
export default Heading;